<app-card-lg [title]="'Warehouses'">
  <div *appLoading="loading$ | async"></div>
  @if (!(loading$ | async)) {
    @for (warehouse of (warehouses$ | async); track warehouse) {
      <app-warehouses-list-item [warehouse]="warehouse"></app-warehouses-list-item>
    }
  }
</app-card-lg>
